import { useMemo } from 'react'
import { SendEmailForm } from '../SendEmailForm'
import { SendEmailFormProps } from '../SendEmailForm/SendEmailForm'
import { ThreadFileAttachmentsPanel } from '../ThreadFileAttachmentsPanel'
import { Doc } from 'types/doc.types'

export type ThreadSendEmailFormProps = Omit<
    SendEmailFormProps,
    'files' | 'onChangeFiles'
> & {
    threadId: string
    customerId?: string
    documents: Doc[]
    onChangeSelectedThreadDocuments: (documents: Doc[]) => void
}

export const ThreadSendEmailForm = (args: ThreadSendEmailFormProps) => {
    const {
        threadId,
        documents,
        onChangeSelectedThreadDocuments,
        ...sendEmailFormArgs
    } = args

    const customComponents = useMemo(() => {
        return threadId ? (
            <ThreadFileAttachmentsPanel
                threadId={threadId}
                customerId={args.customerId}
                documents={documents}
                onChangeSelectedThreadDocuments={
                    onChangeSelectedThreadDocuments
                }
            />
        ) : null
    }, [threadId, documents])

    return (
        <SendEmailForm
            {...sendEmailFormArgs}
            files={[]}
            onChangeFiles={() => undefined}
            customComponents={customComponents}
        />
    )
}
